import React from 'react';
import arrowLeft from '../assets/icons/arrowLeft.svg';
import arrowRight from '../assets/icons/arrowRigth.svg';
import useWindowSize from '../hooks/useWindowSize';

const centerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  textAlign: 'center',
};

function SectionsInfo({
  title, description, isSlider = false, handleNext,
  handlePrev, isPartner, center, isFaq, showButtons = true, isAboutUs = false,
}) {
  const { width } = useWindowSize();

  const descriptionNode = isAboutUs ? (
    <p
      style={{ color: isPartner ? '#fff' : '' }}
      className="section__info-dercription"
      dangerouslySetInnerHTML={{ __html: description }}
    />
  ) : (
    <p style={{ color: isPartner ? '#fff' : '' }} className="section__info-dercription">
      {description}
    </p>
  );

  return (
    <div
      style={{
        ...(center && width > 768 && { ...centerStyles, flexDirection: isFaq ? 'column' : '' }),
      }}
      className="section__info"
    >
      <h2 style={{ color: isPartner ? '#fff' : '' }} className="title section__info-title">
        {title}
      </h2>

      {(!isSlider || width < 768) ? descriptionNode : (
        <div className="swiper-buttons">
          {showButtons && (
            <>
              {descriptionNode}
              <div className="swiper-button-row">
                <button
                  onClick={handlePrev}
                  type="button"
                  className={`swiper-button prev ${isPartner ? 'partner' : ''}`}
                >
                  <img src={arrowLeft} alt="arrow left" />
                </button>
                <button
                  onClick={handleNext}
                  type="button"
                  className={`swiper-button next ${isPartner ? 'partner' : ''}`}
                >
                  <img src={arrowRight} alt="arrow right" />
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default SectionsInfo;
